function processPipe(pipeString) {
  const values = pipeString.split('|');
  const pipe = {};
  values.forEach((item, i) => {
    pipe[`r${i}`] = item;
  });
  return pipe;
}

module.exports = processPipe;



// WEBPACK FOOTER //
// ./src/modules/processPipe.js